import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { uploadPropertyImages } from "../../../services/propertyService";
import { serializePropertyImages } from "../../../utils/admin/parsePropertyImages";

/**
 * Hook dùng chung cho form tạo mới và chỉnh sửa bất động sản.
 * @param {Function} submitFn - Hàm gọi API tương ứng (create hoặc update)
 * @param {string} redirectPath - Đường dẫn sau khi submit thành công
 */
export function usePropertyForm(submitFn, redirectPath = "/my-properties") {
  const navigate = useNavigate();

  const [formData, setFormData] = useState(null);
  const [imageFiles, setImageFiles] = useState([]);
  const [existingImages, setExistingImages] = useState([]);
  const [uploading, setUploading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleFileChange = (e) => {
    setImageFiles(Array.from(e.target.files));
  };

  const handleRemoveImage = (indexToRemove) => {
    setExistingImages((prev) => prev.filter((_, i) => i !== indexToRemove));
  };

  const handleSubmit = async () => {
    if (existingImages.length + imageFiles.length === 0) {
      toast.warning("Vui lòng chọn ít nhất 1 ảnh bất động sản.");
      return;
    }

    setUploading(true);
    try {
      let newUrls = [];
      if (imageFiles.length > 0) {
        const { urls } = await uploadPropertyImages(imageFiles);
        newUrls = urls;
      }

      const dataToSend = {
        ...formData,
        images: serializePropertyImages(existingImages, newUrls),
        price: parseFloat(formData.price),
        area: parseFloat(formData.area),
        bedrooms: parseInt(formData.bedrooms),
        bathrooms: parseInt(formData.bathrooms),
        isSold: formData.isSold === true,
        isNew: formData.isNew === true,
      };

      await submitFn(dataToSend);
      toast.success("✅ Thao tác thành công!");
      navigate(redirectPath);
    } catch (err) {
      console.error("Lỗi khi submit bất động sản:", err);
      toast.error("❌ Thao tác thất bại.");
    } finally {
      setUploading(false);
    }
  };

  return {
    formData,
    setFormData,
    imageFiles,
    setImageFiles,
    existingImages,
    setExistingImages,
    uploading,
    handleChange,
    handleFileChange,
    handleRemoveImage,
    handleSubmit,
  };
}